import { Subscription } from 'rxjs';
import { environment } from './../../../environments/environment';
import { Component, HostListener, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { UserService } from 'src/app/data/services/user.service';
import { AuthComponent } from 'src/app/modules/auth/auth.component';
import { Helper } from 'src/app/shared/helper';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { UserProfileModalComponent } from '../modals/user-profile-modal/user-profile-modal.component';
import { LoaderService } from 'src/app/data/services/loader.service';
import { userDetailsModel } from 'src/app/core/models/userDetails.model';
import { AuthService } from 'src/app/shared/auth.service';
import { LanguageService } from 'src/app/shared/language.service';
import { AdminSettingsService } from 'src/app/shared/admin-settings.service';
import { CartService } from 'src/app/data/services/cart.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnDestroy {
  modalRef!: NgbModalRef;
  loginUser: any = null ;
  isLogin: boolean = false;
  imageUrl = environment.IMAGE_URL;
  profileObservable!: Subscription;
  modalConfig = {
    centered: true,
    ariaLabelledBy: 'modal-basic-title',
    size: 'sm',
  };
  @ViewChild('authModel', { static: false }) authModel!: AuthComponent;
  @ViewChild('logout_popup', { static: false }) logout_popup!: TemplateRef<any>;
  @ViewChild('profileModal', { static: false })
  profileModal!: UserProfileModalComponent;
  isSticky: boolean = false;
  isNavbar : boolean = false ;

  @HostListener('window:scroll', [])
  onWindowScroll() {
    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    this.isSticky = scrollPosition > 50; // Adjust the threshold as needed
  }

  constructor(
    private userService: UserService,
    public helper: Helper,
    private modalService: NgbModal,
    public loader: LoaderService,
    private _authService: AuthService,
    private langconfig: LanguageService,
    private adminSettingsService: AdminSettingsService,
    public cartService: CartService
  ) {}

  async ngOnInit() {
    this.loader._isMainLoading = true ;
    this.profileObservable = this.userService._userdataObservable.subscribe((res) => {
        this.loginUser = this.helper.userDetails;    
        if(this.loginUser){
          this.isLogin = true;
        }
      })
    this.loader._isMainLoading = false ;
  }

  login() {
    this.authModel.open();
  }

  onProfile() {
    this.profileModal.open();
  }

  logout() {
    // this.modalRef = this.modalService.open(this.logout_popup, this.modalConfig);
    localStorage.removeItem('userToken');
    localStorage.removeItem('loginData');
    this.helper.jwt_token = '';
    this.helper._route.navigate(['/']);
      setTimeout(() => {
        location.reload();
      }, 1000);
  }

  onRegister() {
    this.authModel.registerModal();
  }

  getSettings() {
    this.adminSettingsService.getAdminDetails({}).subscribe((res:any) => {
      if(res){
        this.helper.adminSettings = res[0];
      }
    }); 
  }

  close() {
    this.modalRef.close();
  }

  navToggle(){
    this.isNavbar = !this.isNavbar;
  }

  get cartItemCount(): number {
    return this.cartService.getItemCount();
  }

  confirm() {
    localStorage.removeItem('login_token');
    localStorage.removeItem('login_data');
    this.helper.jwt_token = '';
    location.reload();
  }

  ngOnDestroy(): void {
    this.profileObservable?.unsubscribe();
  }
}
